export const IMAGE_BACKGROUND_TYPE = 'image';
export const VIDEO_BACKGROUND_TYPE = 'video';
export const COVER_MIN_HEIGHT = 50;

export function backgroundImageStyles(url) {
  return url ? { backgroundImage: `url(${url})` } : {};
}

export const CSS_UNITS = [
  { value: 'px', label: 'px', default: 430 },
  { value: 'em', label: 'em', default: 20 },
  { value: 'rem', label: 'rem', default: 20 },
  { value: 'vw', label: 'vw', default: 20 },
  { value: 'vh', label: 'vh', default: 50 },
];

export function dimRatioToClass(ratio) {
  return ratio === 0 || ratio === 50 || !ratio
    ? null
    : 'has-background-dim-' + 10 * Math.round(ratio / 10);
}
